var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.93349 1.39453C9.73548 1.39453 12.0096 3.66861 12.0096 6.4706C12.0096 9.27258 9.73548 11.5467 6.93349 11.5467C4.1315 11.5467 1.85742 9.27258 1.85742 6.4706C1.85742 3.66861 4.1315 1.39453 6.93349 1.39453ZM6.93349 10.5314C9.17711 10.5314 10.9943 8.71422 10.9943 6.4706C10.9943 4.22698 9.17711 2.40974 6.93349 2.40974C4.68987 2.40974 2.87264 4.22698 2.87264 6.4706C2.87264 8.71422 4.68987 10.5314 6.93349 10.5314ZM8.72838 3.95794L9.44614 4.6757L6.93349 7.18835L6.21573 6.4706L8.72838 3.95794Z",
    fill: "#5C5C5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_93"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.1826,
    height: 12.1826,
    fill: "white",
    transform: "translate(0.841797 0.379395)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArr);
export default __webpack_public_path__ + "static/media/arr.c84ac95e5d37922c7894b1a066075f12.svg";
export { ForwardRef as ReactComponent };